/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePersonaRequest } from './CreatePersonaRequest';
import {
    CreatePersonaRequestFromJSON,
    CreatePersonaRequestFromJSONTyped,
    CreatePersonaRequestToJSON,
    CreatePersonaRequestToJSONTyped,
} from './CreatePersonaRequest';

/**
 * 
 * @export
 * @interface BulkCreatePersonasRequest
 */
export interface BulkCreatePersonasRequest {
    /**
     * 
     * @type {Array<CreatePersonaRequest>}
     * @memberof BulkCreatePersonasRequest
     */
    personas: Array<CreatePersonaRequest>;
}

/**
 * Check if a given object implements the BulkCreatePersonasRequest interface.
 */
export function instanceOfBulkCreatePersonasRequest(value: object): value is BulkCreatePersonasRequest {
    if (!('personas' in value) || value['personas'] === undefined) return false;
    return true;
}

export function BulkCreatePersonasRequestFromJSON(json: any): BulkCreatePersonasRequest {
    return BulkCreatePersonasRequestFromJSONTyped(json, false);
}

export function BulkCreatePersonasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreatePersonasRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'personas': ((json['personas'] as Array<any>).map(CreatePersonaRequestFromJSON)),
    };
}

export function BulkCreatePersonasRequestToJSON(json: any): BulkCreatePersonasRequest {
    return BulkCreatePersonasRequestToJSONTyped(json, false);
}

export function BulkCreatePersonasRequestToJSONTyped(value?: BulkCreatePersonasRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personas': ((value['personas'] as Array<any>).map(CreatePersonaRequestToJSON)),
    };
}

